var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "no-border-shadow", attrs: { tabindex: "0" } },
    _vm._l(_vm.colors, function(colorSets, index) {
      return _c(
        "b-row",
        { key: index, staticClass: "row-even" },
        _vm._l(colorSets, function(color, innerIndex) {
          return _c(
            "b-col",
            { key: innerIndex, staticClass: "p-0", attrs: { cols: "2" } },
            [
              _c("div", {
                staticClass: "color",
                style: { backgroundColor: color },
                on: {
                  click: function($event) {
                    _vm.emitColor(color)
                  }
                }
              })
            ]
          )
        })
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0a9801a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a9801a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ColorPicker.vue
// module id = 1322
// module chunks = 2